import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header";
import {
  acceptAggregatorInviteAction,
  getAggregatoerByIdAction,
  getAggregatoerByPhone,
} from "../../redux/actions/AggregatorAction";
import { getToken } from "../../redux/actions/userActions";

import { useLocation } from "react-router-dom";
import { Reducers } from "../../Interfaces/Interfaces";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router";
import InviteImage from "../../images/check-invite.png";
export default function AggregatorInvite() {
  const search = useLocation().search;
  const aggregatorId = new URLSearchParams(search).get("aggregatorid");
  const superAggregatorId = new URLSearchParams(search).get(
    "superaggregatorId"
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const getAggregatorById = useSelector(
    (state: any) => state.getAggregatorById
  );
  const { enqueueSnackbar } = useSnackbar();
  const alert = useSelector((state: Reducers) => state.alert);
  const [loader, setloader] = React.useState(false);
  const [message, setmessage] = React.useState("");
  React.useEffect(() => {
    let token = {
      client_id: "client",
      client_secret: "secret",
      grant_type: "client_credentials",
    };

    dispatch(getToken(token));
    if (
      Object.keys(getAggregatorById).length === 0 ||
      !aggregatorId ||
      !superAggregatorId
    ) {
      dispatch({
        type: "LOADING",
        payload: true,
      });
    } else {
      dispatch({
        type: "LOADING",
        payload: false,
      });
    }
  }, [dispatch, alert]);
  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        setloader(false);

        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        enqueueSnackbar(alert.message, { variant: "success" });
        // handleRefresh();
        setmessage(
          "You have been successfully mapped to your super aggregator"
        );
        setloader(false);
        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);

  React.useEffect(() => {
    dispatch(getAggregatoerByIdAction(superAggregatorId));
  }, []);
  const handleAccept = () => {
    setloader(true);
    let data = {
      aggregatorId,
      superAggregatorId,
    };
    dispatch(acceptAggregatorInviteAction(data));
  };
  const handleBack = () => {
    history.push("/");
  };
  return (
    <div style={{ background: "white", height: "100vh" }}>
      <div
        className="container col-md-3 col-12"
        style={{
          marginTop: "40px",
          paddingTop: "20px",
          paddingBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <img
            src={InviteImage}
            alt="logo"
            style={{ width: "96px", height: "96px" }}
          />
        </div>

        <div
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontSize: "25px",
            fontWeight: 700,
          }}
        >
          Onboarding Invite
        </div>

        {message ? (
          <div style={{ textAlign: "center" }}>
            {message}

            <div
              style={{ width: "100%", textAlign: "center", marginTop: "20px" }}
            >
              <button
                style={{
                  borderRadius: "26px",
                  color: "white",
                  background: "#219AF3",
                  padding: "5px 20px 5px 20px",
                  border: "none",
                }}
                onClick={handleBack}
              >
                back
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div className="row" style={{ marginBottom: "20px" }}>
              <div
                className="col"
                style={{ fontSize: "15px", fontWeight: 600 }}
              >
                SUPER AGGREGATOR NAME
              </div>
              <div
                className="col"
                style={{
                  fontSize: "15px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {getAggregatorById ? (
                  <span>
                    <span>
                      {getAggregatorById.firstName
                        ? getAggregatorById.firstName
                        : ""}{" "}
                    </span>
                    <span>
                      {getAggregatorById.lastName
                        ? getAggregatorById.lastName
                        : ""}
                    </span>
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row" style={{ marginBottom: "20px" }}>
              <div
                className="col"
                style={{ fontSize: "15px", fontWeight: 600 }}
              >
                PHONE NUMBER
              </div>
              <div
                className="col"
                style={{
                  fontSize: "15px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {getAggregatorById ? (
                  <span> {getAggregatorById.phoneNumber}</span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row" style={{ marginBottom: "20px" }}>
              <div
                className="col"
                style={{ fontSize: "15px", fontWeight: 500 }}
              >
                <button
                  style={{
                    borderRadius: "26px",
                    color: "black",

                    padding: "5px 20px 5px 20px",
                    border: "none",
                  }}
                  onClick={handleBack}
                >
                  Cancel
                </button>
              </div>
              <div
                className="col"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {loader ? (
                  <button
                    style={{
                      borderRadius: "26px",
                      color: "white",
                      background: "#0E94DD",
                      padding: "5px 20px 5px 20px",
                      border: "none",
                    }}
                  >
                    Please wait...
                  </button>
                ) : (
                  <button
                    onClick={handleAccept}
                    style={{
                      borderRadius: "26px",
                      color: "white",
                      background: "#0E94DD",
                      padding: "5px 20px 5px 20px",
                      border: "none",
                    }}
                  >
                    Accept
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
